<template>
  <el-dialog
     class="node-detail common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-descriptions class="margin-top" :column="1" :border="true">
      <el-descriptions-item v-for="(item, i) in labelList" :key="i">
        <template slot="label">
          {{ item.label }}
        </template>
        <template v-if="item.formatter">
          {{ item.formatter(resultObj[item.value]) }}
        </template>
        <template v-else>
          {{ resultObj[item.value] || $constants.EMPTY }}
        </template>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleCancel">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddNode',
  data() {
    return {
      title: '节点详情',
      dialogVisible: false,
      labelList: [
        { label: '节点名称', value: 'name' },
        { label: 'IP地址', value: 'ip' },
        { label: 'Path', value: 'path' },
        { label: '开放端口', value: 'port' },
        { label: '加入区块链', value: 'chainId' },
        { label: '角色', value: 'nodeRole' },
        { label: '状态', value: 'status' },
        { label: '证书情况', value: 'nodeCrtCid' }
      ],
      resultObj: {
        name: '',
        ip: '',
        path: '',
        port: '',
        chainId: '',
        nodeRole: '',
        status: '',
        nodeCrtCid: ''
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(row) {
      let param = {
        id: row.id,
        offset: 0,
        limit: 1
      }
      this.getDetail(param)
      this.dialogVisible = true
    },
    getDetail(param) {
      this.$apis.node.getNodeManageList(param).then(res => {
        if (res.data && res.data.items) {
          let item = res.data.items[0]
          Object.keys(this.resultObj).map(ele => {
            if (ele === 'ip') {
              this.resultObj[ele] = item.addr.split(':')[0]
            } else if (ele === 'port') {
              this.resultObj[ele] = item.addr.split(':')[1]
            } else {
              this.resultObj[ele] = item[ele]
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('node-detail', (), ());
.node-detail {
  @include adaptation((
    --node-detail-dialog-body-padding-bottom: 20px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-width);

    .el-dialog__body {
      padding-bottom: var(--node-detail-dialog-body-padding-bottom);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
